
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"#fff"}},[_c('path',{attrs:{"d":"M47.908 22.5H45v-5.223A2.28 2.28 0 0042.723 15h-1.056V0H8.332v1.667h-2.5v1.666h-2.5v5.834H2.277A2.28 2.28 0 000 11.443V47.85h.005c-.004.47.142.929.435 1.313A2.121 2.121 0 002.137 50h37.3c.964 0 1.812-.65 2.04-1.51L50 25.123v-.147c0-1.435-.88-2.477-2.092-2.477zm-5.185-5.833a.61.61 0 01.61.61V22.5h-1.666v-5.833h1.056zM40 1.667V22.5H10.609c-.194 0-.38.032-.562.082-.015.004-.032.002-.047.006V1.667h30zM8.333 3.333v21.321l-.052.144-.781 2.14V3.333h.833zM5 5h.833v26.508L5 33.792V5zm-3.333 6.443a.61.61 0 01.61-.61h1.056v27.453l-1.666 4.546V11.443zM39.89 47.987a.469.469 0 01-.453.346h-37.3a.46.46 0 01-.373-.185c-.052-.068-.133-.213-.102-.34l1.671-4.583 2.5-6.853 2.5-6.855v.003l1.61-4.418.057-.154.133-.366.022-.068a.472.472 0 01.454-.347H47.908c.316 0 .398.455.418.682L39.89 47.987z"}}),_c('path',{attrs:{"d":"M15 14.167h20a.833.833 0 100-1.667H15a.833.833 0 100 1.667zM15 8.333h8.333a.833.833 0 100-1.666H15a.833.833 0 100 1.666zM15 20h20a.833.833 0 100-1.667H15A.833.833 0 1015 20z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h50v50H0z"}})])])])
          )
        }
      }
    